import React, { useState } from 'react';
import { useAuthContext } from '../../context/AuthContext';
import TodoForm from '../TodoForm';
import TodoList from '../TodoList';
import SharedTodosList from '../SharedTodosList';
import CategoryManager from '../categories/CategoryManager';
import Calendar from '../calendar/Calendar';
import TaskCompletionStats from '../stats/TaskCompletionStats';

const Dashboard = () => {
  const { user } = useAuthContext();
  const [showCategoryManager, setShowCategoryManager] = useState(false);
  const [showSharedTodos, setShowSharedTodos] = useState(false);
  const [activeView, setActiveView] = useState('list'); // 'list' o 'calendar'
  
  return (
    <div className="container mx-auto px-4">
      <div className="mb-8 text-center">
        <h1 className="text-2xl font-bold text-gray-800 dark:text-white">
          Benvenuto/a, {user ? user.name : 'Utente'}
        </h1>
        <p className="text-gray-600 dark:text-gray-400">Gestisci le tue attività</p>
      </div>
      
      <div className="mb-6 flex flex-wrap gap-4 justify-between items-center">
        <div className="flex space-x-4">
          <button
            onClick={() => setActiveView('list')}
            className={`px-4 py-2 rounded-md transition-colors ${
              activeView === 'list'
                ? 'bg-blue-500 text-white'
                : 'bg-gray-200 text-gray-700 dark:bg-gray-700 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-600'
            }`}
          >
            Lista
          </button>
          <button
            onClick={() => setActiveView('calendar')}
            className={`px-4 py-2 rounded-md transition-colors ${
              activeView === 'calendar'
                ? 'bg-blue-500 text-white'
                : 'bg-gray-200 text-gray-700 dark:bg-gray-700 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-600'
            }`}
          >
            Calendario
          </button>
          <button
            onClick={() => setShowSharedTodos(!showSharedTodos)}
            className={`px-4 py-2 rounded-md transition-colors ${
              showSharedTodos
                ? 'bg-blue-500 text-white'
                : 'bg-gray-200 text-gray-700 dark:bg-gray-700 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-600'
            }`}
          >
            {showSharedTodos ? 'Nascondi Condivisi' : 'Mostra Condivisi'}
          </button>
        </div>
        
        <button
          onClick={() => setShowCategoryManager(!showCategoryManager)}
          className="inline-flex items-center px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors"
        >
          {showCategoryManager ? 'Nascondi Categorie' : 'Gestisci Categorie'}
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            className={`h-5 w-5 ml-2 transition-transform ${showCategoryManager ? 'transform rotate-180' : ''}`} 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </button>
      </div>
      
      {showCategoryManager && (
        <div className="mb-6">
          <CategoryManager />
        </div>
      )}
      
      <div className="grid gap-6 mb-6">
        <TaskCompletionStats />
        {showSharedTodos && (
          <div className="bg-white dark:bg-gray-800 shadow-md rounded-lg p-6">
            <h2 className="text-xl font-semibold mb-4 text-gray-800 dark:text-white">
              Task Condivisi
            </h2>
            <SharedTodosList />
          </div>
        )}
      </div>
      
      <div className="bg-white dark:bg-gray-800 shadow-md rounded-lg p-6 max-w-4xl mx-auto">
        <TodoForm />
        <div className="mt-6">
          {activeView === 'list' ? <TodoList /> : <Calendar />}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;